export const checkFollowing = (user, item) => user.following.some(ele => ele.username === item.username);